// eslint-ignore
export default 
`//Active
<Toggle v-model="value"/>
<p>Value:{{ value }}</p>

//Disabled
<Toggle v-model="valueNo" disabled/>
<Toggle v-model="valueYes" disabled/>


export default {
  components: { Toggle },
  
  data() {
    return { 
      value: false,
      valueNo: false, 
      valueYes: true, 
    }
  }
}`;